export const safetyBeltPledge = (name?: string, date?: string) => {
  return [
    { text: 'Safety Belt Pledge', style: 'h1' },

    { text: [
        { text: 'I, '},
        { text: ` ${name}, `, bold: true },
        { text: 'have received a copy of Sierra Expediting inc safety belt policy.'},
      ], style: 'p', margin: [0, 10, 0, 10] },

    { text: 'I have read the company policy and have had the opportunity to ask questions. I fully understand the company’s penalty for violation of this policy.', style: 'p' },
    { text: 'I hereby pledge that I will use safety belts whenever driving or riding in a company vehicle or in any other vehicle when on company business.', style: 'p' },
    { text: 'I also pledge that passengers of vehicles that I am driving will wear safety belts.', style: 'p' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Supervisor's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};